import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  top_bar: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    height: "44px",
    justifyContent: "space-between",
    margin: "24px 0px !important",
    padding: "4px",
    width: "100%",
    zIndex: 1,
  },
  page_title: {
    color: "#1A0244",
    fontFamily: "Gellix",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "24px",
    lineHeight: "32px",
    margin: "0px",
    textAlign: 'left',
  },
  page_title_ar: {
    color: "#1A0244",
    fontFamily: "TheSansArab",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "24px",
    lineHeight: "32px",
    margin: "0px",
    textAlign: 'right',
  },
  profil_infos: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    cursor: 'pointer',
  },
  lang_selected: {
    // alignItems: "center",
    // display: "flex",
    // justifyContent: "center",
    cursor: 'pointer',
    border: '1px solid #C4C0D3',
    borderRadius: '5px',
    background: '#FFFFFF',
    width: '115px'
  },
  ctn_text_lang_selected: {
    // display: "flex",
    flexDirection: "column",
    // justifyContent: "center",
    // alignItems: "flex-end",
    padding: "0px",
    gap: "1px",
    // width: "80px",
    height: "33px",
    fontFamily: 'Gellix',
    fontSize: '14px',
    fontWeight: 500,
  },
  text_lang_selected: {
    fontFamily: 'Gellix',
    fontSize: '14px',
    fontWeight: 500,
    textTransform: 'capitalize',
    margin: '5px 0px 8px 5px'
  },
  text_field: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-end",
    margin: '0 15px',
    padding: "0px",
    gap: "1px",

    width: "80px",
    height: "33px",
  },
  user_avatar: {
    color: "#1A0244",
    background: "#EDEAF1",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "8px",
    width: "40px",
    height: "40px",
    borderRadius: "200px",
  },
  usr_name: {
    textAlign: "right",
    color: "#1A0244",
    fontFamily: "Gellix",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "12px",
    lineHeight: "16px",
    margin: "0px",
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    overflow: "hidden !important",
    textOverflow: 'ellipsis !important',
  },
  profil_menu: {
    backgroundColor: "rgba(0, 0, 0 , 0)",
  },
  logout_btn: {
    alignItems: "center",
    textAlign: "center",
    backgroundColor: "#fff",
    color: "#1A0244",
    fontFamily: "Gellix",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "10px",
    lineHeight: "16px",
    margin: "0px",
    padding: "",
  },
  ctnMenuLang: {
    border: '1px solid #C4C0D3',
    position: 'relative',
    zIndex: 1,
    background: '#FFFFFF',
    width: '125px',
    borderRadius: '5px',
    padding: '4px 0px 4px 0px',
  },
  elemLang:{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "self-start",
    // margin: '0 15px',
    gap: "1px",
    width: "94%",
    height: "33px",
    fontFamily: 'Gellix',
    fontSize: '14px',
    fontWeight: 500,
    cursor:'pointer',
    '&:hover':{
      background: 'rgb(228, 226, 253)',
    }
  }
}));
